import { marginConcessionApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

import { extractErrorMessage } from '../marginCenter.actionUtils';

export const CONCESSION_ACTION_TYPE = createNamedActions('marginCenter/concession', {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  GET_CONCESSIONS: 'GET_CONCESSIONS',
  SET_DECISION_SAVING: 'SET_DECISION_SAVING',
  SET_DECISION_ERROR: 'SET_DECISION_ERROR',
  RESOLVE_CONCESSION: 'RESOLVE_CONCESSION',
  CLEAR_DECISION_ERROR: 'CLEAR_DECISION_ERROR',
});

// DEV-4977/MC-12: the full concession list (pending + decided) — mirrors marginChangeRequestApi's
// getPending, except this fetches the whole queue: Concessions needs the PENDING subset for the
// actionable queue AND the DECIDED (Approved/AutoApproved) subset to compute real consumed-budget
// totals for Guardrails' Concession Budgets tab, so both screens share one fetch/selector.
export const getConcessionsAction = () => async dispatch => {
  dispatch({ type: CONCESSION_ACTION_TYPE.SET_LOADING, payload: true });

  try {
    const { data } = await marginConcessionApi.getConcessions();

    return dispatch({ type: CONCESSION_ACTION_TYPE.GET_CONCESSIONS, payload: data });
  } catch {
    return dispatch({ type: CONCESSION_ACTION_TYPE.SET_ERROR });
  }
};

// Approve executes the guarded decision server-side (duplicate-open-request / budget-exhausted checks
// live in MarginConcessionService). Returns the decided row on success, null on failure — the caller
// surfaces the reduced errorMessage inline.
export const approveConcessionAction = (concessionRequestId, note) => async dispatch => {
  dispatch({ type: CONCESSION_ACTION_TYPE.SET_DECISION_SAVING, payload: true });

  try {
    const { data } = await marginConcessionApi.approve(concessionRequestId, note);

    dispatch({ type: CONCESSION_ACTION_TYPE.RESOLVE_CONCESSION, payload: data });

    return data;
  } catch (error) {
    dispatch({
      type: CONCESSION_ACTION_TYPE.SET_DECISION_ERROR,
      payload: extractErrorMessage(error),
    });

    return null;
  }
};

export const rejectConcessionAction = (concessionRequestId, note) => async dispatch => {
  dispatch({ type: CONCESSION_ACTION_TYPE.SET_DECISION_SAVING, payload: true });

  try {
    const { data } = await marginConcessionApi.reject(concessionRequestId, note);

    dispatch({ type: CONCESSION_ACTION_TYPE.RESOLVE_CONCESSION, payload: data });

    return data;
  } catch (error) {
    dispatch({
      type: CONCESSION_ACTION_TYPE.SET_DECISION_ERROR,
      payload: extractErrorMessage(error),
    });

    return null;
  }
};

export const clearConcessionDecisionErrorAction = () => dispatch =>
  dispatch({ type: CONCESSION_ACTION_TYPE.CLEAR_DECISION_ERROR });
